module.exports = __webpack_public_path__ + "static/img/Electric01.3a284f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/Buy/Electric/Electric01.jpg
// module id = Lf+Z
// module chunks = 12